import {useQuery} from 'react-query';
import {getCooperationAgreementStatus} from './getCooperationAgreementStatus';
import {IGetCooperationAgreementStatusResponse} from './types';

const useGetCooperationAgreementStatus = () => {
  const {data, isLoading, refetch} =
    useQuery<IGetCooperationAgreementStatusResponse>(
      ['get-cooperation-agreement-status'],
      () => getCooperationAgreementStatus(),
    );

  const contractStatus = data?.status;
  return {contractStatus, isLoading, refetch};
};

export default useGetCooperationAgreementStatus;
